import PreviewDetailImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from '../common';

const routes = [
    {
        matchRegex: '/Job/Detail/:id',
        name: 'Job detail',
        slots: [
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_TAB
        ],
        image: PreviewDetailImg,
    },
]

export default routes;

